module.exports = __webpack_public_path__ + "img/buttonbackground.ee11e0a3.png";